module.exports = __webpack_public_path__ + "img/bq-bo.c82fc5a3.svg";